import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

interface BlueskyPost {
  uri: string;
  text: string;
  createdAt: string;
  url: string | null;
  imageUrl: string | null;
  author: {
    handle: string;
    displayName: string;
    avatar: string | null;
  };
  engagement: {
    likes: number;
    reposts: number;
    replies: number;
  };
}

interface BlueskyFeedResponse {
  posts: BlueskyPost[];
  cursor: string | null;
  source: {
    handle: string;
    displayName: string;
    avatar: string | null;
    followers: number;
    verified: boolean;
  };
}

interface BlueskyMultiFeedResponse {
  posts: (BlueskyPost & { sourceHandle: string })[];
  feeds: { handle: string; count: number }[];
  errors: { handle: string; error: string }[];
}

export function useBlueskyFeed(handle: string, limit = 20) {
  return useQuery({
    queryKey: ['bluesky', 'feed', handle, limit],
    queryFn: () => apiClient.get<BlueskyFeedResponse>(`/bluesky/feed/${handle}?limit=${limit}`),
    enabled: !!handle,
  });
}

export function useBlueskyFeeds(handles: string[], limit = 10) {
  return useQuery({
    queryKey: ['bluesky', 'feeds', handles, limit],
    queryFn: () => apiClient.post<BlueskyMultiFeedResponse>('/bluesky/feeds', { handles, limit }),
    enabled: handles.length > 0,
  });
}

// Default news handles
export const DEFAULT_NEWS_HANDLES = [
  'cnn.com',
  'nytimes.com',
  'washingtonpost.com',
  'apnews.com',
  'reuters.com',
  'bbc.com',
  'npr.org',
  'wsj.com',
];
